import onBoardImage1 from '/public/siteImages/iOSTheme/onBoardPage/theme1/onBoardImage1.png';
import onBoardImage2 from '/public/siteImages/iOSTheme/onBoardPage/theme2/onBoardImage2.png';
import onBoardImage3 from '/public/siteImages/iOSTheme/onBoardPage/theme2/onBoardImage3.png';
import onBoardImage4 from '/public/siteImages/iOSTheme/onBoardPage/theme2/onBoardImage4.png';
import onBoardImage5 from '/public/siteImages/iOSTheme/onBoardPage/theme3/onBoardImage5.png';
import onBoardImage6 from '/public/siteImages/iOSTheme/onBoardPage/theme3/onBoardImage6.png';
import onBoardImage7 from '/public/siteImages/iOSTheme/onBoardPage/theme3/onBoardImage7.png';
import onBoardImage8 from '/public/siteImages/iOSTheme/onBoardPage/theme4/onBoardImage8.png';

export {
    onBoardImage1,
    onBoardImage2,
    onBoardImage3,
    onBoardImage4,
    onBoardImage5,
    onBoardImage6,
    onBoardImage7,
    onBoardImage8
}